export default __webpack_public_path__ + "47043b55a40347dcf19a6d78066746b9.svg";